import React from "react";
import './spinnerLoader.css';

const SpinnerLoader = () => {

    return (
        <>
            <div className="spinnerMain">
                <div className="spinnersub">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </>
    )
};

export default SpinnerLoader;